module.exports = __webpack_public_path__ + "static/media/facebook.672fe130.jpg";